module.exports = __webpack_public_path__ + "static/media/automation.5d35f000.svg";